<template>
  <div class="match-algorithm-config">
    <module-container
      :title="pushTypeName"
      :show-icon="stroke - true - gray - 100"
      :padding="false"
    >
    </module-container>
    <scholar-panel />
  </div>
</template>

<script>
import ModuleContainer from '@comp/moduleContainer'
import ScholarPanel from '@/views/steps/ScholarPanel.vue'
export default {
  name: 'MatchAlgorithmConfig',
  components: {
    ModuleContainer,
    ScholarPanel
  },
  computed: {
    pushTypeName() {
      const typeMap = {
        1: '整期推送',
        2: '专题推送',
        3: '通知推送',
        4: '单篇推送',
        5: '主题推送'
      }
      return typeMap[this.$route.query.type] || ''
    }
  }
}
</script>
